// extracted by mini-css-extract-plugin
module.exports = {"card":"styles-module__card___1ByB8"};